
export class ColorValue {
  public rgbValue: string = "";
  public alphaValue: number = 0;
}
export class ColorPalette {
  public primaryColor: ColorValue = new ColorValue();
  public primaryColorLight: ColorValue = new ColorValue();
  public secondaryColor: ColorValue = new ColorValue();
  public secondaryColorLight: ColorValue = new ColorValue();
}

export class ThemeConfigResponse {
  public colorPalette: ColorPalette = new ColorPalette();
}